import InputField from "@components/form/InputField";

export default function MainInfoTabProfile({ patient }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <div><InputField label="First name" value={patient.first_name || ""} disabled /></div>
      <div><InputField label="Last name" value={patient.last_name || ""} disabled /></div>
      <div><InputField label="Email ID" value={patient.email || ""} disabled /></div>
      <div><InputField label="Phone Number" value={patient.phone_number || ""} disabled /></div>
      <div><InputField label="Insurance Provider" value={patient.insurance_provider || ""} disabled /></div>
      <div><InputField label="Policy Number" value={patient.policy_number || ""} disabled /></div>
      <div><InputField label="Assigned Doctor" value={patient.assigned_doctor || ""} disabled /></div>
    </div>
  );
}
